module.exports = __webpack_public_path__ + "img/icon_primary_menu_systemSettings@2x.c7f71f29.png";